import gql from 'graphql-tag';

const DELETE_LISTING = gql`
  mutation DeleteListing($params: DeleteListingParams!) {
    deleteListing(params: $params)
  }
`;

export default DELETE_LISTING;
